module.exports = __webpack_public_path__ + "static/media/cybex-70t-console.ec3af454.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/developerApi/developerSdk/Archives/images/cybex-70t-console.png
// module id = 1148
// module chunks = 0